<template>
    <transition
            mode="out-in"
            name="modal-backdrop-animation">
        <div class="custom-modal" v-if="showBackdrop === true">
            <div class="close-btn clickable" @click="hideModal">
                <i class="ic-cross"></i>
            </div>
            <transition
                    mode="out-in"
                    name="modal-content-animation">
                <div class="modal-wrapper" v-if="showContent">
                    <slot></slot>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'modal',
        props: {
            show: false
        },
        data() {
            return {
                showContent: false,
                showBackdrop: false
            }
        },
        methods: {
            hideModal() {
                this.showContent = false;
                setTimeout(() => {
                    this.showBackdrop = false;
                }, 182);
            },
            showModal() {
                this.showBackdrop = true;
                setTimeout(() => {
                    this.showContent = true;
                }, 262);
            }
        },
        watch: {
            show(val) {
                this.showBackdrop = val;
            }
        }
    }
</script>

<style scoped>
    .modal-backdrop-animation-enter-active, .modal-backdrop-animation-leave-active {
        /*transition: all .2625s cubic-bezier(.215,.61,.355,1);*/
        transition: all .4625s cubic-bezier(.215,.61,.355,1);
    }

    .modal-backdrop-animation-enter, .modal-backdrop-animation-leave-to
    {
        opacity: 0;
    }

    .modal-content-animation-enter-active, .modal-content-animation-leave-active {
        /*transition: all .2625s cubic-bezier(.215,.61,.355,1);*/
        transition: all .4625s cubic-bezier(.215,.61,.355,1);
    //transition-delay: .2625s;
    }

    .modal-content-animation-enter
    {
        opacity: 0;
        transform: scale(0.75);
    }

    .modal-content-animation-leave-to {
        opacity: 0;
        transform: scale(1.25);
    }
</style>